export default "__VITE_ASSET__D1G1pBEJ__"